module.exports = __webpack_public_path__ + "img/1_2.11b2558e.jpg";